import React, { useState } from 'react'
import withStyles from 'constructicon/with-styles'
import styles from './styles'
import { leaveTeam } from 'supporticon/api/teams'

import Button from '../../../../ui/Button'
import ButtonGroup from 'constructicon/button-group'
import Confirm from '../../../../ui/Confirm'
import Section from 'constructicon/section'

const TeamDetails = ({
  onLeave,
  pageSlug,
  styles,
  team,
  token
}) => {
  const [status, setStatus] = useState('fetched')

  return (
    <Section
      styles={styles.root}
      spacing={{ y: 3 }}>
      <p>You are a part of <strong>{team.name}</strong></p>
      <Section spacing={{ t: 0.5 }}>
        <ButtonGroup>
          <Button to={`/teams/${team.slug}`}>
            View Team
          </Button>
          <Confirm
            background='light'
            foreground='primary'
            onConfirm={() => {
              const params = {
                teamSlug: team.slug,
                pageSlug,
                token
              }

              Promise.resolve()
                .then(() => setStatus('fetching'))
                .then(() => leaveTeam(params))
                .then(() => onLeave())
                .catch(error => {
                  setStatus('failure')
                  return Promise.reject(error)
                })
            }}>
            {status === 'fetching'
              ? 'Leaving...'
              : 'Leave Team'}
          </Confirm>
        </ButtonGroup>
      </Section>
    </Section>
  )
}

export default withStyles(styles)(TeamDetails)
